<template>
    <div class="sport-categories">
        <carousel v-if="categories.length"
            :paginationEnabled="false"
            :navigationEnabled="true"
            navigation-next-label=""
            navigation-prev-label=""
            :scrollPerPage="false"
            :perPageCustom="[
                [320, 1.3],
                [400, 1.7],
                [450, 1.8],
                [525, 2.2],
                [600, 2.5],
                [768, 1.8],
                [900, 2.2],
                [1000, 2.5],
                [1150, 3.5],
                [1300, 3.5],
                [1400, 4],
                [1500, 4.5],
                [1600, 5],
                [1800, 6]
            ]"
        >
            <slide v-for="(category, index) of categories"
                :key="index"
            >
                <router-link :id="`category-${index}`"
                    :to="category.link"
                    :class="['category', { 'category--disabled': category.isDisabled }]"
                >
                    <div class="category__background"
                        :style="{ backgroundImage: 'url(' + category.background + ')' }"
                    />
                    <span>{{ category.name }}</span>
                    <loading-spinner v-if="category.background" />
                </router-link>
            </slide>
        </carousel>
    </div>
</template>

<script>
// Components
import loadingSpinner from '@webapp/components/loading-spinner/loading-spinner.vue';
import {
    Carousel,
    Slide,
} from 'vue-carousel';

// 3rd Party
import {
    mapGetters,
} from 'vuex';

export default {
    name: 'sport-categories',
    components: {
        loadingSpinner,
        Carousel,
        Slide,
    },
    computed: {
        ...mapGetters([
            'sportsLeaguesList',
            'getTranslatedStr',
        ]),
        ...mapGetters('partners', ['partnersBySport']),

        categories() {
            return this.sportsLeaguesList.map((sport) => ({
                name: this.getTranslatedStr(sport, 'name', sport.name),
                background: this.getImageUrl(sport.images),
                isDisabled: sport.name.includes('Coming Soon'),
                id: sport.id,
                link: this.getLink(sport),
            })).filter((sport) => sport.link || sport.isDisabled);
        },
    },
    methods: {
        getImageUrl(images) {
            const image = images.find((image) => image.imageType.type === 'mobile_menu');

            return image ? image.url : null;
        },
        getLink(category) {
            const partners = this.partnersBySport(category.id);

            if (partners.length === 0) {
                return '';
            } else if (partners.length === 1) {
                return `/partner/${partners[0].id}`;
            }

            return `/sports/${category.id}`;
        },
    },
};
</script>

<style lang="scss" scoped>
.category {
    margin: 1rem 2rem 2.5rem;
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 10rem;
    width: 16rem;
    border-radius: 0.75rem;
    box-shadow: 0 1rem 1.5rem rgba($black-color, 0.25);
    color: $white-color;
    font-family: "Galano Grotesque Medium";
    font-size: 2.5rem;
    font-weight: 600;
    text-transform: uppercase;
    transition: 0.05s ease-in;
    cursor: pointer;
    background: $dusty-gray-color;
    background-size: cover;
    text-decoration: none;
    text-align: center;
    line-height: 1;

    &:hover {
        opacity: 0.8;
    }

    span {
        position: relative;
        z-index: 3;
    }

    &--disabled {
        box-shadow: unset;
        pointer-events: none;
    }

    &__background {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 0.75rem;
        z-index: 2;
        background-repeat: no-repeat;
        background-size: cover;
    }
}

.spinner {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
}
</style>